import Router from 'vue-router';
import login from './login';
import todos from './todos';
import billing from './billing';
import projects from './projects';

export default function (Vue) {
	Vue.use(Router);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				name: 'page-home',
				redirect: '/projects',
				children: [todos, projects, billing],
				component: () => import('@/pages/page-home'),
				meta: {
					title: 'Home',
				},
			},
			login,
			{
				name: 'synchronize-companies-list',
				path: 'synchronize-companies-list',
				meta: {
					title: 'Sincronización de compañías',
				},
				component: () => import('@/components/configuration/synchronize-companies-list'),
			}
		],
	});
	config.beforeEach((to, from, next) => {
		if (to.name !== 'login') {
			const token = window.localStorage.getItem(`${process.env.STORAGE_USER_KEY}::token`);
			if (token || to.name === 'synchronize-companies-list') {
				return next();
			}
			return next({ name: 'login' });
		}
		return next();
	});
	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js